/** Preserve HTTP status so query retries can distinguish access denials. */
export class ApiError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export function shouldRetryQuery(failureCount: number, error: Error): boolean {
  return failureCount < 1 && !(error instanceof ApiError && error.status === 403);
}
